import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { USERROUTES } from './url-constant';

const UserProtectedRoute = ({ component }) => {
    let location = useLocation(),
        UserRawAccessToken = useSelector((state) => state?.employeeAccessToken?.value);
    UserRawAccessToken = UserRawAccessToken
        ? (UserRawAccessToken)
        : UserRawAccessToken;

    if (!UserRawAccessToken) {
        return <Navigate to={USERROUTES?.USERLOGIN} state={{ from: location }} replace />
    }
    return component;
}

export default UserProtectedRoute;

